import { render, staticRenderFns } from "./ProgressTextArea.vue?vue&type=template&id=5c2808f0&scoped=true"
import script from "./ProgressTextArea.vue?vue&type=script&lang=js"
export * from "./ProgressTextArea.vue?vue&type=script&lang=js"
import style0 from "./ProgressTextArea.vue?vue&type=style&index=0&id=5c2808f0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c2808f0",
  null
  
)

export default component.exports